/**
 * @author kkakkuro0
 * @date 2024.10.08
 * @description 상품 카드
 */

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {IProduct} from '../../../../store/useProduct';
import LazyImage from '../../../form/LazyImage';

const ProductImageCard = ({
  id,
  franchiseId,
  franchiseName,
  productName,
  thumbnailFile,
}: IProduct) => {
  const navigate = useNavigate();
  
  const moveToProductDetail = useCallback(() => {
    navigate(`/product-image/${id}/${franchiseId}`);
  }, [navigate, id, franchiseId]);
  return (
    <div className="!bg-white !rounded-lg !overflow-hidden !cursor-pointer !transition-all !duration-200 !ease-in-out !border !border-gray-200 hover:!shadow-lg hover:!border-gray-300 !group" onClick={moveToProductDetail}>
      <div className="!w-full !pt-[100%] !relative !overflow-hidden !bg-gray-100">
        {thumbnailFile?.fileFullUrl ? (
          <LazyImage
            src={thumbnailFile.fileFullUrl}
            alt="saju_product_img"
            className="!absolute !top-0 !left-0 !w-full !h-full !object-cover !transition-transform !duration-300 group-hover:!scale-105"
            skeleton="!absolute !top-0 !left-0 !w-full !h-full !bg-gradient-to-r !from-gray-200 !via-gray-100 !to-gray-200 !animate-pulse"
          />
        ) : (
          <div className="!absolute !top-0 !left-0 !w-full !h-full !bg-gray-200 !flex !items-center !justify-center">
            <span className="!text-gray-400 !text-sm">이미지 없음</span>
          </div>
        )}
      </div>
      <div className="!p-4">
        <h3 className="!text-[16px] font-bold !font-normal !leading-[22px] !text-gray-800 !mb-2 !line-clamp-2 !min-h-[22px]">회사 명: {franchiseName}</h3>
          <span className="!text-[13px]">
              {productName}
          </span>
      </div>
    </div>
  );
};

export default ProductImageCard;
